import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export interface DialerSettings {
  id: string;
  user_id: string | null;
  concurrency: number;
  from_number: string | null;
  ring_timeout_seconds: number;
  machine_action: 'hangup' | 'voicemail';
  voicemail_message: string | null;
  max_attempts_per_contact: number;
  retry_interval_hours: number;
  allowed_start_hour: number;
  allowed_end_hour: number;
  create_task_on_no_answer: boolean;
}

export const DIALER_SETTINGS_KEY = ['dialer-settings'];

export function useDialerSettings() {
  return useQuery({
    queryKey: DIALER_SETTINGS_KEY,
    queryFn: async (): Promise<DialerSettings | null> => {
      const { data, error } = await supabase
        .from('dialer_settings')
        .select('*')
        .is('user_id', null)
        .maybeSingle();
      if (error) throw error;
      return (data as unknown as DialerSettings) ?? null;
    },
  });
}

export function useUpdateDialerSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: Partial<DialerSettings> & { id: string }) => {
      const { id, ...values } = payload;
      const { error } = await supabase.from('dialer_settings').update(values).eq('id', id);
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: DIALER_SETTINGS_KEY });
      toast.success('Configurações do discador salvas');
    },
    onError: (error: Error) => {
      toast.error(`Erro ao salvar: ${error.message}`);
    },
  });
}
